<template>
  <el-dialog title="编辑" :visible.sync="formVisible" width="900px" :close-on-click-modal="false" v-if="formVisible">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="功能名称：" prop="functionName" class="width100">
        <el-input v-model="form.functionName" placeholder="请输入功能名称" />
      </el-form-item>
      <el-form-item label="编码：" prop="code" class="width100">
        <el-input v-model="form.code" placeholder="请输入编码" />
      </el-form-item>
      <el-form-item label="位置：" prop="functionType" class="width100">
        <el-select v-model="form.functionType" placeholder="请选择" clearable size="small">
          <el-option label="首页" :value="1"></el-option>
          <el-option label="患者管理" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图片：" prop="icon" class="width100">
        <div class="flexs">
          <imageUpload v-model="form.icon" width="32" height="32" />
          <span class="hint hint1">限制上传1张<br />建议尺寸710x320像素以上</span>
        </div>
      </el-form-item>
      <jurisd :form="form" title="入口权限" />
      <el-form-item label="排序：" prop="orderNo" class="width100">
        <el-input v-model="form.orderNo" placeholder="请输入功能名称" />
      </el-form-item>
      <el-form-item label="未登录是否展示：" prop="isLoginVisible" class="width100">
        <el-switch v-model="form.isLoginVisible" :active-value="true" :inactive-value="false" :active-text="form.isLoginVisible?'显示':'不显示'"></el-switch>
      </el-form-item>
      <el-form-item label="状态：" prop="functionStatus" class="width100">
        <el-switch v-model="form.functionStatus" :active-value="1" :inactive-value="0" :active-text="form.functionStatus?'上架':'下架'"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import functionTypesApi from '@/api/marketing/functionTypes'
import ImageUpload from "@/components/ImageUpload";
import Jurisd from './jurisd.vue'
function initFormBean() {
  const formBean = {
    functionName: '',
    icon: '',
    code: '',
    orderNo: '',
    functionStatus: 0,
    isLoginVisible:true,
    isAuthInsider: false,
    isAuthSubAccount: false,
  }
  return formBean
}

export default {
  components: { ImageUpload, Jurisd },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        functionName: [{ required: true, message: '请输入功能名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        icon: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
      query: {
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form.pageNo = 1
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      // 只保留被选中的authCustLevel和authTechLevel的key
      if (Array.isArray(params.authCustLevel)) {
        params.authCustLevel = params.authCustLevel
          .filter(item => item.isActive)
          .map(item => item.key)
          .join(',')
      }
      if (Array.isArray(params.authTechLevel)) {
        params.authTechLevel = params.authTechLevel
          .filter(item => item.isActive)
          .map(item => item.key)
          .join(',')
      }
      // 确保 isAuthInsider 和 isAuthSubAccount 被正确传递（布尔值）
      params.isAuthInsider = params.isAuthInsider === true || params.isAuthInsider === 1
      params.isAuthSubAccount = params.isAuthSubAccount === true || params.isAuthSubAccount === 1
      return params
    },
    /**
     * 提交表单
     */
    doCreate() {
      let params = this.calcParams()
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.form.id > 0) {
            functionTypesApi.update(params).then((data) => {
              this.postCallback(data)
            });
          } else {
            functionTypesApi.create(params).then((data) => {
              this.postCallback(data)
            });
          }
        }
      });
    },
    /**
     * 回调
     */
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.reward-type {
  display: flex;
  & > .el-select {
    &:first-child {
      width: 180px;
      margin-right: 10px;
    }
  }
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
</style>
